import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const signMarginAgreement = () =>
  fetchApi({
    auth: true,
    method: 'POST',
    url: getApiUrl('nabu-gateway/exchange/margin/agreement/sign')
  })
